"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.newIdFormQuestions = void 0;
const lib_logger_1 = __importDefault(require("@opsbase/lib-logger"));
const uuid = __importStar(require("uuid"));
const getEnabledChildQuestions_1 = __importDefault(require("../helpers/getEnabledChildQuestions"));
function newIdFormQuestions(form) {
    return (form || []).map(newIdFormQuestion);
}
exports.newIdFormQuestions = newIdFormQuestions;
exports.default = newIdFormQuestions;
function newIdFormQuestion(q) {
    try {
        q.originalQId = q.qId;
        q.qId = uuid.v4();
        (0, getEnabledChildQuestions_1.default)(q).forEach(newIdFormQuestion);
        return q;
    }
    catch (err) {
        lib_logger_1.default.error('Unexpected error in newIdFormQuestion', { err });
        return q;
    }
}
